module.exports = __webpack_public_path__ + "static/media/idoHoko.b26cab5f.png";